export enum AppModules {
  REQUESTS = 'Enquiries',
  CLIENTS = 'Customers',
  QUOTES = 'Quotes',
  SUPPLIERS = 'Suppliers',
  SUPPLIER_DOCUMENTS = 'Supplier_Documents',
  PRODUCTS_SERVICES = 'Products_Services',
  INVENTORIES = 'Inventory',
  JOBS = 'Jobs',
  PURCHASE_ORDERS = 'Purchase_Orders',
  TEAM_MEMBERS = 'Team_Members',
  TIMESHEETS = 'Timesheets',
  EXPENSES = 'Expenses',
  INVOICES = 'Invoicing',
  REPORTS = 'Reports',
  SETTINGS = 'Settings',
}

export enum SupplierDocumentType {
  INVOICE = 1,
  PURCHASE_ORDER = 2,
  CREDIT_NOTE = 3,
  // Expandable for future types
  // DEBIT_NOTE = 4,
  // STATEMENT = 5,
}

export enum SupplierFileType {
  PDF = 1,
  CSV = 2,
  XLS = 3,
  XLSX = 4,
  TXT = 5,
  DOC = 6,
  DOCX = 7,
  JPG = 8,
  PNG = 9,
}

export enum SupplierDocumentStatus {
  QUEUED = 1,
  PROCESSING = 2,
  PROCESSED = 3,
  FAILED = 4,
  REVIEW = 5,
  VERIFY = 6,
  APPROVED = 7,
}
